import React, { useState } from "react";
import { Upload } from "lucide-react";
import { uploadImage } from "../../lib/adminApi";
import { resolveMediaUrl } from "../../lib/mediaUrl";
import { AdminField } from "./AdminUi";

export function MediaInput({ label, value, onChange, className = "" }) {
  const [mode, setMode] = useState(() =>
    value?.startsWith("/uploads") ? "upload" : "url"
  );
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState("");

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    setUploadError("");
    try {
      const { url } = await uploadImage(file);
      onChange(url);
      setMode("upload");
    } catch {
      setUploadError("Görsel yüklenemedi. Format ve boyutu kontrol edin.");
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  const previewSrc = value ? resolveMediaUrl(value) : null;

  return (
    <AdminField label={label} className={className}>
      <div className="flex gap-2 mb-2">
        <button
          type="button"
          onClick={() => setMode("url")}
          className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
            mode === "url"
              ? "bg-[var(--tv-purple)] text-white"
              : "bg-[rgba(255,255,255,0.06)] text-[var(--tv-muted)] hover:text-white"
          }`}
        >
          URL
        </button>
        <button
          type="button"
          onClick={() => setMode("upload")}
          className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-colors inline-flex items-center gap-1.5 ${
            mode === "upload"
              ? "bg-[var(--tv-purple)] text-white"
              : "bg-[rgba(255,255,255,0.06)] text-[var(--tv-muted)] hover:text-white"
          }`}
        >
          <Upload size={12} /> Yükle
        </button>
      </div>

      {mode === "url" ? (
        <input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="tv-input"
          placeholder="https://... veya /images/..."
        />
      ) : (
        <div>
          <input
            type="file"
            accept="image/jpeg,image/png,image/webp,image/gif"
            onChange={handleFile}
            disabled={uploading}
            className="tv-input file:mr-3 file:py-1 file:px-3 file:rounded file:border-0 file:text-xs file:bg-[var(--tv-purple)] file:text-white"
          />
          {uploading && <p className="text-xs text-[var(--tv-muted)] mt-1">Yükleniyor...</p>}
        </div>
      )}

      {uploadError && <p className="text-xs text-red-400 mt-1">{uploadError}</p>}

      {previewSrc && (
        <img
          src={previewSrc}
          alt=""
          className="mt-3 w-full max-h-32 object-cover rounded-lg border border-[var(--tv-border)]"
        />
      )}
    </AdminField>
  );
}
